import styled from "styled-components";

export const FlashImage = styled.img`
  border-radius: 1rem;
  height: 12rem;
  object-fit: cover;
  margin: -2rem -1rem 0 -1rem;
  pointer-events: none;
`;
